export default {"src":"/_next/static/media/image-landscape.d5e92fc6.svg","height":18,"width":21};